module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/step02-0db0b09c708325e61850b18be38af8a5.png";